<template>
  <div class="fill-height">
    <Header />
    <div v-if="loading" class="text-center mt-10">
      <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
    </div>
    <div v-else>
      <slot />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  name: "DefaultLayout",
  components: {
    Header,
    Footer
  },
    data() {
    return {
      loading: false
    };
  },
  computed: {
    hasToken() {
      return this.$store.getters.hasToken;
    }
  }
};
</script>